module.exports = __webpack_public_path__ + "img/10market2.73af4281.png";